(function () {
  'use strict';

  if (!document.querySelector('.section-pdp-shell')) return;

  document.documentElement.classList.add('pdp-active');

  var bg = document.getElementById('pdp-global-bg');
  if (bg && bg.parentElement !== document.body) {
    document.body.insertBefore(bg, document.body.firstChild);
  }

  function setSpotlight(x, y) {
    var spotlight = document.querySelector('[data-pdp-spotlight]');
    if (!spotlight) return;
    spotlight.style.background =
      'radial-gradient(800px circle at ' + x + 'px ' + y + 'px, rgba(255,255,255,0.16), rgba(255,255,255,0.04) 25%, transparent 45%)';
  }

  function bindSpotlight() {
    var spotlight = document.querySelector('[data-pdp-spotlight]');
    if (!spotlight || spotlight.dataset.pdpSpotlightBound === '1') return;
    spotlight.dataset.pdpSpotlightBound = '1';
    setSpotlight(window.innerWidth / 2, window.innerHeight * 0.42);
    document.addEventListener('mousemove', function (e) {
      setSpotlight(e.clientX, e.clientY);
    }, { passive: true });
  }

  function initProductPageScroll() {
    document.documentElement.classList.add('pdp-page');
    if (!document.querySelector('product-info')) return;

    document.documentElement.classList.add('pdp-has-product');

    if (window.location.hash || sessionStorage.getItem('pdp-scroll-init') === '1') return;

    function scrollTopOnce() {
      window.scrollTo(0, 0);
      sessionStorage.setItem('pdp-scroll-init', '1');
    }

    scrollTopOnce();
    requestAnimationFrame(scrollTopOnce);
    window.addEventListener('load', scrollTopOnce, { once: true });
  }

  function init() {
    initProductPageScroll();
    bindSpotlight();

    var reveals = document.querySelectorAll('.pdp-reveal');
    if (reveals.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      reveals.forEach(function (el) { observer.observe(el); });
    }

    document.querySelectorAll('[data-pdp-section] [data-tilt]').forEach(function (card) {
      if (card.dataset.pdpTiltBound === '1') return;
      card.dataset.pdpTiltBound = '1';
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width;
        var y = (e.clientY - rect.top) / rect.height;
        card.style.transform =
          'perspective(1000px) rotateX(' + ((0.5 - y) * 15) + 'deg) rotateY(' + ((x - 0.5) * 15) + 'deg) scale3d(1.02,1.02,1.02)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.documentElement.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="email"]')) {
      document.documentElement.classList.add('pixelmob-email-focus');
    }
  });
  document.documentElement.addEventListener('focusout', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="email"]')) {
      document.documentElement.classList.remove('pixelmob-email-focus');
    }
  });

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.classList && ev.target.classList.contains('section-pdp-shell')) {
      var bgEl = document.getElementById('pdp-global-bg');
      if (bgEl && bgEl.parentElement !== document.body) {
        document.body.insertBefore(bgEl, document.body.firstChild);
      }
      bindSpotlight();
    }
  });
})();
